import { BuyerTypes } from '../../enums';
import {
  BrandFilterType,
  BuyerTypeFilter,
  CountyFilter,
  TaxFilter,
} from '../../models/Filters';
import { PriceRange } from '../../models/PriceRange';
import { ProductListModel } from '../../models/Product';

export interface FilterSelectionsState {
  selectedTaxClassIds: number[];
  selectedEmployerTaxClassIds: number[];
  selectedCountyIds: number[];
  selectedBrandIds: number[];
  showDiscountedProducts: boolean;
  priceRange?: PriceRange;
  selectedBuyerTypes: BuyerTypes[];
  selectedCategories?: Set<number>;
}

export interface ProductListState {
  productList?: ProductListModel[];
  filtredProductList?: ProductListModel[];
}

export interface AvailableInFilterState {
  availableInList?: CountyFilter[];
  filteredAvailableInList?: CountyFilter[];
}
export interface BrandFilterState {
  brandList?: BrandFilterType[];
  filteredBrandList?: BrandFilterType[];
}
export interface BuyerTypeFilterState {
  buyerTypeList?: BuyerTypeFilter[];
  filteredBuyerTypeList?: BuyerTypeFilter[];
}
export interface TaxationLevelFilterState {
  taxationLevelList?: TaxFilter[];
  filteredTaxationLevelList?: TaxFilter[];
}
export interface PriceRangeFilterState {
  priceRange?: PriceRange;
}
export interface ProductsOnOfferFilterState {
  discountedProductsCount: number;
}

export const filterSelectionDefaults: FilterSelectionsState = {
  selectedTaxClassIds: [] as number[],
  selectedEmployerTaxClassIds: [] as number[],
  selectedCountyIds: [] as number[],
  selectedBrandIds: [] as number[],
  showDiscountedProducts: false,
  selectedBuyerTypes: [] as BuyerTypes[],
};

export type entityType<T> = {
  id: number;
  [key: number]: T;
};

export interface FilterPanelModel {
  filteredAvailableInList?: CountyFilter[];
  filteredBrandList?: BrandFilterType[];
  filteredBuyerTypeList?: BuyerTypeFilter[];
  filteredTaxationLevelList?: TaxFilter[];
  filteredEmployerTaxationLevelList?: TaxFilter[];
  priceRange?: PriceRange;
  discountedProductsCount: number;
  selectionFilterState: FilterSelectionsState;
  hasActiveFilters: boolean;
  priceRangeFilterChanged: (range: PriceRange) => void;
  availableInFilterChanged: (countyIds: number[]) => void;
  brandFilterChanged: (brandIds: number[]) => void;
  buyerTypeFilterChanged: (buyerTypes: BuyerTypes[]) => void;
  taxFilterChanged: (taxClassIds: number[]) => void;
  employerTaxFilterChanged: (taxClassIds: number[]) => void;
  productsOnOfferFilterChanged: (isSelected: boolean) => void;
  clearFilters: () => void;
}
